export const CONFIG_VARS = Object.freeze({
 LIGHT: "light",
 DARK: "dark",
 LIGHT_THEME: "lara-light-indigo",
 DARK_THEME: "lara-dark-indigo",
 SCALE: 14,
});
